import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=352f6674&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=352f6674&lang=scss&scoped=true&"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f6674",
  null
  
)

export default component.exports